import React from 'react';

import Health from './Health.js'
import Keys from './Keys.js'
import CreateKey from './CreateKey.js'
import ChangePassword from './ChangePassword.js'
import { getJWTUsername } from './storage.js'

function Admin({handleLogout}) {
  let username = getJWTUsername();

  return (
    <div className="container block is-max-desktop">
      <h1 className="has-text-weight-bold is-size-1 honey-text-font-family honey-text">HoneyShare Admin</h1>
      <h5 className="has-text-weight-bold is-size-5 honey-text-font-family honey-text-common">User: {username}</h5>
      <Health />
      <Keys />
      <CreateKey />
      <ChangePassword />
      <div className="block">
        <button className="button honey-button" onClick={handleLogout}>Logout</button>
      </div>
    </div>
  )
}

export default Admin;
